/* eslint-disable react/no-array-index-key */

import {Font} from '@samuelmeuli/font-manager';
import {useGlobalState} from 'hooks/useGlobalState';
import FontPickerReact from 'vendors/FontPickerReact/FontPickerReact';
import './FontPicker.scss';

interface IProps {
  onChange?: (font: Font) => void;
  className?: string;
}

export default function FontPicker({onChange, className}: IProps) {
  const {font} = useGlobalState((state) => state.postGenerator);

  const apiKey = process.env.REACT_APP_GOOGLE_FONT_API_KEY;

  return apiKey ? (
    <div className={`font-picker ${className ? className : ''}`}>
      <FontPickerReact apiKey={apiKey} activeFontFamily={font ? font.family : 'Default'} onChange={onChange} />
    </div>
  ) : (
    <p>Invalid api key</p>
  );
}
